import { useQuery } from '@tanstack/react-query';
import { getDocumentCommentLog } from 'services/api/dynamicFormsApi';

/**
 * The comment log of a document, for the comment log page. The log is the whole point of that page, so a failed
 * request throws to the error boundary rather than rendering "No comments found" over an error. The document page
 * does not load the log: it shows its button from the `hasCommentLog` metadata flag.
 */
export const useDocumentCommentLog = (docId: string, enabled: boolean) =>
  useQuery({
    queryKey: ['DOC_COMMENT_LOG', docId],
    queryFn: () => getDocumentCommentLog(docId),
    enabled: enabled && !!docId,
    staleTime: 0,
    refetchOnMount: 'always',
    throwOnError: true,
  });
